import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "crm:w-full crm:relative crm:bg-white js-vue-doc-container crm:pl-2"
}
const _hoisted_2 = { class: "crm:flex crm:flex-col" }
const _hoisted_3 = { class: "crm:my-2 crm:flex crm:flex-col" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "crm:text-secondary" }
const _hoisted_6 = { class: "crm:flex crm:flex-col crm:px-4" }
const _hoisted_7 = { class: "crm:flex crm:justify-between crm:items-center" }
const _hoisted_8 = { class: "crm:w-1/2" }
const _hoisted_9 = { class: "crm:mb-1" }

import docVueJSON from './vue-components-doc.json'
import {useDefineTab} from "../../composable/definer/useDefineTab";
import {inject, reactive, ref} from "vue";
import {new_folder, arrows_down, arrows_up, eye} from '../../svg/svgs.js'


export default {
  __name: 'ComponentsDoc',
  setup(__props) {

const $L_ = inject('$L_');

const vueDoc = reactive({
  list: docVueJSON,
  listDefault: null,
  isReady: false
})

let tabsArr = [];
Object.keys(vueDoc.list).forEach((docKey) => {
  let components = vueDoc.list[docKey];
  tabsArr.push({components: components, controls: docKey, title: docKey})
})

vueDoc.list = $L_.cloneDeep(tabsArr);
vueDoc.listDefault = $L_.cloneDeep(tabsArr);
vueDoc.isReady = true;

const soggettoDettaglioTabs = useDefineTab(vueDoc.list, 'layouts', false)

const ricerca = ref({value: ''})

const getIndexArray = (doc, objKey) => (vueDoc[objKey]).findIndex(object => object.controls === doc.controls)

function updateRicerca(newValue, doc) {
  ricerca.value = {value: newValue.value};
  let index = getIndexArray(doc, 'list');

  if (newValue.value && newValue.value !== '') {
    let listFiltered = (Object.entries(vueDoc.list[index].components)).filter(([key, item]) => {
      return (key.toLowerCase()).includes(newValue.value.toLowerCase()) || (item.description.toLowerCase()).includes(newValue.value.toLowerCase())
    });
    vueDoc.list[index].components = Object.fromEntries(listFiltered)
  }

  if (!newValue.value || newValue.value === '') {
    vueDoc.list[index].components = vueDoc.listDefault[getIndexArray(doc, 'listDefault')].components
  }
}

const isFullScreen = ref(false)

/**
 *
 * @param event
 * @param status
 */
function toggleFullScreen(event = null, status = null) {
  isFullScreen.value = status ? status : !isFullScreen.value
  let elm = event ? event.target.closest('.js-vue-doc-container') : document.querySelector('.js-vue-doc-container')
  if (isFullScreen.value) elm.requestFullscreen()
  if (!isFullScreen.value && document.fullscreenElement) document.exitFullscreen()
}

/**
 * @inject {$DesignSystem} recupera la lista dei colori/configurazioni del design system
 */
const $DesignSystem = inject('$DesignSystem')

const sectionActived = ref(null)

function toggleSection(controls) {
  sectionActived.value = (controls === sectionActived.value) ? null : controls;
}


const updateDocComponent = inject('updateDocComponent')
const updateIsShowComponentDoc = inject('updateIsShowComponentDoc')

function showComponentDoc(component) {
  updateDocComponent(component);
  updateIsShowComponentDoc(true)
}

return (_ctx, _cache) => {
  const _component_base_icon = _resolveComponent("base-icon")

  return (vueDoc.isReady)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(vueDoc.list, (docSection) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("div", {
                class: "crm:flex crm:justify-between crm:cursor-pointer",
                onClick: _withModifiers($event => (toggleSection(docSection.controls)), ["prevent"])
              }, [
                _createElementVNode("span", _hoisted_5, [
                  _createVNode(_component_base_icon, {
                    icon: _unref(new_folder),
                    class: "crm:mr-2",
                    stroke: _unref($DesignSystem).design_colors.ternary
                  }, null, 8 /* PROPS */, ["icon", "stroke"]),
                  _createElementVNode("strong", null, _toDisplayString(docSection.title) + " (" + _toDisplayString(Object.keys(docSection.components).length) + ")", 1 /* TEXT */)
                ]),
                _createVNode(_component_base_icon, {
                  icon: sectionActived.value !== docSection.controls ? _unref(arrows_down) : _unref(arrows_up)
                }, null, 8 /* PROPS */, ["icon"])
              ], 8 /* PROPS */, _hoisted_4),
              (sectionActived.value === docSection.controls)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: _normalizeClass(["crm:mt-4 crm:overflow-y-scroll", [isFullScreen.value ? 'crm:h-[100vh]' : 'crm:h-[calc(100vh-40rem)]']])
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(docSection.components, (comp, compKey) => {
                      return (_openBlock(), _createElementBlock("div", _hoisted_6, [
                        _createElementVNode("div", _hoisted_7, [
                          _createElementVNode("section", _hoisted_8, [
                            _createElementVNode("strong", _hoisted_9, _toDisplayString(compKey), 1 /* TEXT */),
                            _createElementVNode("p", null, _toDisplayString(comp.description), 1 /* TEXT */)
                          ]),
                          _createVNode(_component_base_icon, {
                            icon: _unref(eye),
                            class: "crm:cursor-pointer",
                            onClick: _withModifiers($event => (showComponentDoc({title: compKey, components:comp})), ["prevent"])
                          }, null, 8 /* PROPS */, ["icon", "onClick"])
                        ])
                      ]))
                    }), 256 /* UNKEYED_FRAGMENT */))
                  ], 2 /* CLASS */))
                : _createCommentVNode("v-if", true)
            ]))
          }), 256 /* UNKEYED_FRAGMENT */))
        ])
      ]))
    : _createCommentVNode("v-if", true)
}
}

}